import React from 'react'
import { Document, Page, Text, View, Image, Font } from "@react-pdf/renderer";
import sitlogo from '../../assets/images/sitlogo.png'

const AssignmentDoc = ({ assignmentreport }) => {
    Font.register({
        family: 'Poppins',
        fonts: [
            {
                src: '/fonts/Poppins-Regular.ttf',
                fontWeight: 'normal',
            },
            {
                src: '/fonts/Poppins-SemiBold.ttf',
                fontWeight: 600,
            },
            {
                src: '/fonts/Poppins-Bold.ttf',
                fontWeight: 'bold',
            },
        ],
    });
    function formatDate(dateInput) {
        const date = new Date(dateInput);
        const day = String(date.getDate()).padStart(2, '0');        // dd
        const month = String(date.getMonth() + 1).padStart(2, '0'); // mm (months are 0-indexed)
        const year = date.getFullYear();                            // yyyy

        return `${day}-${month}-${year}`;
    }

    function formatDate2(dateInput) {
        const date = new Date(dateInput);
        const day = String(date.getDate()).padStart(2, '0');       // 06
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthNames[date.getMonth()];                 // Aug
        const year = date.getFullYear();                           // 2014

        return `${day}-${month}-${year}`;
    }


    function paginateData(data, rowsPerPage = 25) {
        const pages = [];
        for (let i = 0; i < data.length; i += rowsPerPage) {
            pages.push(data.slice(i, i + rowsPerPage));
        }
        return pages;
    }


    const studentList = Array.isArray(assignmentreport) ? assignmentreport : [];
    return (
        <Document>
            {paginateData(studentList, 25).map((pageData, pageIndex) => (
                <Page size="A4" style={{ padding: 30, fontSize: 10 }}>
                    <View>
                        <View
                            style={{
                                flexDirection: 'column',
                                justifyContent: "space-between",
                                alignItems: "flex-start",

                            }}>

                            <Image
                                src={sitlogo}
                                style={{ width: "60px" }}
                            ></Image>
                        </View>
                    </View>
                    <View style={{
                        width: "100%",
                        height: "18px",
                        // backgroundColor: "yellow",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "3px solid black",
                    }}>
                        <Text style={{
                            fontSize: 8,
                            textAlign: "center",
                            fontWeight: "bold",
                        }}>ASSIGNMENT RECORD</Text>
                    </View>

                    {/* part 2 */}

                    <View style={{
                        // top: "0.5%",
                        width: "100%",
                        height: "85%",
                        // border: "2px solid black",
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between"
                    }}>
                        <View style={{
                            width: "50%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            borderBottom: "3px solid black",
                            borderRight: "2px solid black",
                            borderLeft: "3px solid black",

                        }}>
                            {/* part 2.1 */}
                            <View style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                // backgroundColor: "yellow",
                                borderBottom: "3px solid black"
                            }}>
                                <View style={{
                                    width: "45%",
                                    height: "3%",
                                    paddingTop: "1%"
                                }}><Text style={{
                                    fontSize: 9,
                                    textAlign: "center"
                                }}>Training Programme :</Text></View>
                                <View style={{
                                    width: "55%",
                                    height: "3%",
                                    paddingTop: "1%"
                                }}><Text style={{ fontSize: 9 }}>{pageData[0].Course_Name}</Text></View>
                            </View>
                            <View style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                height: "5%",
                                // backgroundColor: "yellow",
                                borderBottom: "2px solid black"
                            }}>
                                <View style={{
                                    width: "35%",
                                    paddingBottom: "2%",
                                    paddingTop: "5%",
                                    borderRight: "2px solid black"
                                }}><Text style={{
                                    fontSize: 9,
                                    textAlign: "center"
                                }}>Assignment No</Text></View>
                                <View style={{
                                    width: "65%",
                                    height: "10%",
                                    paddingBottom: "2%",
                                    paddingTop: "5%",

                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>Subject</Text></View>
                            </View>
                            <View style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                height: "3%",
                                // backgroundColor: "yellow",
                                borderBottom: "2px solid black"
                            }}>
                                <View style={{
                                    width: "35%",
                                    // paddingBottom: "2%",
                                    paddingTop: "2%",
                                    borderRight: "2px solid black"
                                }}><Text style={{
                                    fontSize: 9,
                                    textAlign: "center"
                                }}>{pageData[0].assignmentname}</Text></View>
                                <View style={{
                                    width: "65%",
                                    height: "3%",
                                    paddingBottom: "2%",
                                    paddingTop: "2%",

                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>{pageData[0].subjects}
                                    </Text></View>
                            </View>
                            <View style={{ width: "100%", height: "auto", display: "flex", flexDirection: "row", borderBottom: "2px solid black" }}>
                                <View style={{
                                    borderRight: "2px solid black",
                                    width: "8%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    gap: "2px"
                                    // height: "10%"
                                }}><Text style={{ fontSize: 9, textAlign: "center", paddingTop: "2px" }}>Sr </Text>
                                    <Text style={{ fontSize: 9, textAlign: "center", paddingBottom: "2px" }}>No</Text>
                                </View>
                                <View style={{
                                    borderRight: "2px solid black",
                                    width: "40%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>Name</Text></View>
                                <View style={{
                                    borderRight: "2px solid black",
                                    width: "18%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>Sub.Date</Text></View>
                                <View style={{
                                    borderRight: "2px solid black",
                                    width: "10.26%",
                                    display: "flex",
                                    justifyContent: "center",

                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>Marks </Text></View>
                                <View style={{
                                    // borderRight: "1px solid black",
                                    width: "10.26%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRight: "2px solid black",
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>SubSign</Text></View>
                                <View style={{
                                    // borderRight: "1px solid black",
                                    width: "10.26%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>RecdSign</Text></View>


                            </View>
                            {/* part 3 */}

                            {pageData.map((item, index) => (
                                <View wrap={false} style={{ width: "100%", flexGrow: 1, display: "flex", flexDirection: "row", borderBottom: "1px solid black" }}>
                                    <View style={{
                                        borderRight: "1px solid black",
                                        width: "8%",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        // height: "10%"
                                    }}><Text style={{ fontSize: 9, textAlign: "center", paddingTop: "2px" }}>{item.index}</Text>

                                    </View>
                                    <View style={{
                                        borderRight: "1px solid black",
                                        width: "40%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}><Text style={{ fontSize: 9, textAlign: "center" }}>{item.Student_Name}</Text></View>
                                    <View style={{
                                        borderRight: "1px solid black",
                                        width: "18%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center"
                                    }}><Text style={{ fontSize: 9, textAlign: "center" }}>{formatDate(item.Actual_Dt)}</Text></View>
                                    <View style={{
                                        borderRight: "1px solid black",
                                        width: "10.26%",
                                        display: "flex",
                                        justifyContent: "center",

                                    }}><Text style={{ fontSize: 9, textAlign: "center" }}>{item.Marks_Given}</Text></View>
                                    <View style={{
                                        // borderRight: "1px solid black",
                                        width: "10.26%",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRight: "1px solid black",
                                    }}><Text style={{ fontSize: 9, textAlign: "center" }}></Text></View>
                                    <View style={{
                                        // borderRight: "1px solid black",
                                        width: "10.26%",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}><Text style={{ fontSize: 9, textAlign: "center" }}></Text></View>


                                </View>
                            ))}
                        </View>
                        <View style={{
                            width: "50%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            borderBottom: "3px solid black",
                            borderRight: "3px solid black",

                        }}>
                            <View style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                // backgroundColor: "yellow",
                                borderBottom: "3px solid black"
                            }}>
                                <View style={{
                                    width: "45%",
                                    height: "3%",
                                    paddingTop: "1%"
                                }}><Text style={{
                                    fontSize: 9,
                                    textAlign: "center"
                                }}>Batch No :-</Text></View>
                                <View style={{
                                    width: "55%",
                                    height: "3%",
                                    paddingTop: "1%"
                                }}><Text style={{ fontSize: 9 }}>{pageData[0].Batch_code}</Text></View>
                            </View>
                            <View style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                height: "5%",
                                // backgroundColor: "yellow",
                                borderBottom: "2px solid black"
                            }}>
                                <View style={{
                                    width: "66%",
                                    paddingBottom: "2%",
                                    paddingTop: "5%",
                                    borderRight: "2px solid black"
                                }}><Text style={{
                                    fontSize: 9,
                                    textAlign: "center"
                                }}>Date</Text></View>
                                <View style={{
                                    width: "34%",
                                    height: "10%",
                                    paddingBottom: "2%",
                                    paddingTop: "5%",

                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>Total Marks </Text></View>
                            </View>
                            <View style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                height: "3%",
                                // backgroundColor: "yellow",
                                borderBottom: "2px solid black"
                            }}>
                                <View style={{
                                    width: "66%",
                                    // paddingBottom: "2%",
                                    paddingTop: "2%",
                                    borderRight: "2px solid black"
                                }}><Text style={{
                                    fontSize: 9,
                                    textAlign: "center"
                                }}>{formatDate2(pageData[0]?.Actual_Dt)}</Text></View>
                                <View style={{
                                    width: "34%",
                                    height: "3%",
                                    paddingBottom: "2%",
                                    paddingTop: "2%",

                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>{pageData[0].marks}</Text></View>
                            </View>
                            {/*  */}
                            <View style={{ width: "100%", height: "auto", display: "flex", flexDirection: "row", borderBottom: "2px solid black" }}>
                                <View style={{
                                    borderRight: "2px solid black",
                                    width: "8%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",

                                    gap: "2px"
                                    // height: "10%"
                                }}><Text style={{ fontSize: 9, textAlign: "center", paddingTop: "2px" }}>Sr </Text>
                                    <Text style={{ fontSize: 9, textAlign: "center", paddingBottom: "2px" }}>No</Text>
                                </View>
                                <View style={{
                                    borderRight: "2px solid black",
                                    width: "40%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>Name</Text></View>
                                <View style={{
                                    borderRight: "2px solid black",
                                    width: "18%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>Sub.Date</Text></View>
                                <View style={{
                                    borderRight: "2px solid black",
                                    width: "10.26%",
                                    display: "flex",
                                    justifyContent: "center",

                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>Marks </Text></View>
                                <View style={{
                                    // borderRight: "1px solid black",
                                    width: "10.26%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRight: "2px solid black",
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>SubSign</Text></View>
                                <View style={{
                                    // borderRight: "1px solid black",
                                    width: "10.26%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}>RecdSign</Text></View>


                            </View>
                            {/* part 3 */}

                            <View style={{ width: "100%", flexGrow: 1, display: "flex", flexDirection: "row", borderBottom: "1px solid black" }}>
                                <View style={{
                                    borderRight: "1px solid black",
                                    width: "8%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    // height: "10%"
                                }}><Text style={{ fontSize: 9, textAlign: "center", paddingTop: "2px" }}> </Text>

                                </View>
                                <View style={{
                                    borderRight: "1px solid black",
                                    width: "40%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}></Text></View>
                                <View style={{
                                    borderRight: "1px solid black",
                                    width: "18%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}></Text></View>
                                <View style={{
                                    borderRight: "1px solid black",
                                    width: "10.26%",
                                    display: "flex",
                                    justifyContent: "center",

                                }}><Text style={{ fontSize: 9, textAlign: "center" }}> </Text></View>
                                <View style={{
                                    // borderRight: "1px solid black",
                                    width: "10.26%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderRight: "1px solid black",
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}></Text></View>
                                <View style={{
                                    // borderRight: "1px solid black",
                                    width: "10.26%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}><Text style={{ fontSize: 9, textAlign: "center" }}></Text></View>


                            </View>
                        </View>
                    </View>

                    {/* end part */}
                    <View style={{
                        marginTop: "1%",
                        display: "flex", flexDirection: "row",
                        justifyContent: "space-between",
                        paddingLeft: "2%",
                        paddingRight: "2%",
                        width: "100%",
                    }}>
                        <View style={{ display: "flex", justifyContent: "start", }}>
                            <Text style={{ fontSize: 8 }}>F/005/00</Text>
                        </View>
                        <View style={{ display: "flex", justifyContent: "start", }}>
                            <Text style={{ fontSize: 8 }}>1</Text>
                        </View>
                    </View>
                </Page>
            ))}
        </Document>
    )
}

export default AssignmentDoc
